import axiosInstance from "../../../Services/Global-Services/UnauthorizedTokenHandler";
import { checkStatus, getHeaders } from "../../../Services/SharedSevices/SharedServices";
const baseURL = process.env.REACT_APP_BASE_URL

//For Get The Doc of the organization.
export const FolderDocumentContains = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Document/Get`, params, {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}
//For Update The Folder And Document.
export const FolderDocumentUpdate = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Document/Add`, params, {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

// //For Get The Doc of the organization.
// export const getFolder = async (params) => {
//   try {
//     const response = await axiosInstance.get(`${baseURL}/Document/Label/Get?OrgId=${params?.OrgId}`,{
//       headers: await getHeaders(),
//       body: JSON.stringify(params)
//     });
//     checkStatus(response);
//     return response.data;
//   } catch (error) {
//     return Promise.reject(error);
//   }
// }

//For Get The Doc of the organization.
export const makeDocumentPinn = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Document/Pinned/UnPinned`,params,{
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}


export const DeleteDocument = async (params) => {
 try {
    const response = await axiosInstance.post(`${baseURL}/Document/Delete`,params,{
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export const FolderMarkAsFav = async (params) => {
   try {
    const response = await axiosInstance.post(`${baseURL}/Document/MarkFav`,params,{
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export const moveFolderData = async (params) => {
  try {
const response = await axiosInstance.post(`${baseURL}/Document/Move/Folder`,params,{
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  }
  catch (error){
return Promise.reject(error);
  }
}


export const versionHistoryListData = async (params) => {
   try {
const response = await axiosInstance.post(`${baseURL}/Document/History?DocId=${params?.DocId}`,params,{
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  }
  catch (error){
return Promise.reject(error);
  }
}

export const uploadDocFile = async (params , formData) => {
    const additionalHeaders = {};
  const headers = await getHeaders(additionalHeaders, ['authorization']);
  try {
    const response = await axiosInstance.post(`${baseURL}/Master/UploadDocFile?UploadType=${params?.UploadType}&RefId=${params?.RefId}`, formData, {
      headers: headers,
      body: formData
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}